// Which logged listing appointment belongs to this pipeline lead? Used by the
// auto-classifier (lead graduates → appointment won; lead lost → lost), so
// the appointment log keeps itself current instead of waiting for a human.
//
// Join keys, strongest first — appointments carry different links depending
// on where they were created (Goals modal, intake form, pipeline sync):
//   1. appointment.leadId === lead.id           (goals sync stamped it)
//   2. appointment.id === lead.sourceAppointmentId (lead minted FROM the appt)
//   3. appointment.dealId === lead.sourceDealId  (both born from one intake)
//   4. same normalized address                   (the Archive Converted Leads
//      matcher, proven in production; street line only, case/punct-blind)
import { normalizeAddressKey } from "./statusSheetData";

export function findAppointmentForLead(appointments = [], lead = {}) {
  const appts = (appointments || []).filter(Boolean);
  const leadId = String(lead?.id || "");
  const srcApptId = String(lead?.sourceAppointmentId || "");
  const srcDealId = String(lead?.sourceDealId || "");

  const byLead =
    leadId && appts.find((a) => String(a.leadId || "") === leadId);
  if (byLead) return byLead;

  const byApptId =
    srcApptId && appts.find((a) => String(a.id || "") === srcApptId);
  if (byApptId) return byApptId;

  const byDeal =
    srcDealId && appts.find((a) => String(a.dealId || "") === srcDealId);
  if (byDeal) return byDeal;

  const addrKey = normalizeAddressKey(lead?.propertyAddress || "");
  if (addrKey) {
    return (
      appts.find(
        (a) =>
          normalizeAddressKey(a.address || a.propertyAddress || "") === addrKey,
      ) || null
    );
  }
  return null;
}
